module.exports = require('./assignIn');



// WEBPACK FOOTER //
// ./~/lodash/extend.js